import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-tweet/dist/hooks.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-tweet/dist/twitter-theme/icons/icons.module.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-tweet/dist/twitter-theme/quoted-tweet/quoted-tweet-container.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-tweet/dist/twitter-theme/theme.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-tweet/dist/twitter-theme/tweet-actions-copy.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-tweet/dist/twitter-theme/tweet-container.module.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-tweet/dist/twitter-theme/tweet-header.module.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-tweet/dist/twitter-theme/tweet-info-created-at.module.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-tweet/dist/twitter-theme/quoted-tweet/quoted-tweet-header.module.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-tweet/dist/twitter-theme/skeleton.module.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-tweet/dist/twitter-theme/tweet-media-video.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-tweet/dist/twitter-theme/verified-badge.module.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-tweet/dist/twitter-theme/tweet-in-reply-to.module.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-tweet/dist/twitter-theme/tweet-link.module.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-tweet/dist/twitter-theme/tweet-body.module.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-tweet/dist/twitter-theme/tweet-media.module.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-tweet/dist/twitter-theme/tweet-info.module.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-tweet/dist/twitter-theme/tweet-actions.module.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-tweet/dist/twitter-theme/tweet-replies.module.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-tweet/dist/twitter-theme/quoted-tweet/quoted-tweet-body.module.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-tweet/dist/twitter-theme/tweet-not-found.module.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-tweet/dist/twitter-theme/tweet-skeleton.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/article-video-player.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/category.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/collapsible.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/format-date.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/infront/company-fundamentals.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/infront/financial-calendar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/infront/instrument-overview.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/infront/ranking-list.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/infront/simple-instrument-list.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/infront/single-value.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/infront/technical-chart.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/instrument-news-tabs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/item-feed.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/linked-content/podcast.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/page-block/components/menu-block.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/page-builder/components/grid-with-filter/grid-articles.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/podcast-play-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/reels-viewer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/slider/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/teaser-slider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/teaser/podcast/horizontal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/teaser/podcast/small.tsx");
